
import React from 'react';
import {createRoot} from 'react-dom/client';

import './common/styles/index.scss';
import MultiStepForm from "./common/components/MultiStepForm";

const App = () => {

	const currentPath = window.location.pathname; // Obtient le chemin actuel de l'URL
	const mode = currentPath.includes('facultatif') ? 2 : 1;

	return (
		<div>
			<MultiStepForm mode={mode} />
		</div>
	);
};

class WebComponent extends HTMLElement {
	connectedCallback() {
		this.root = createRoot(this);
		this.root.render(<App />, this);
	}
}

const ELEMENT_ID = 'mutelios-devis-app';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}